import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { WorkScheduleTemplate } from '../models/WorkScheduleTemplate'
import { WorkScheduleTemplateForm } from '../forms/WorkScheduleTemplateForm'
import { WorkScheduleTemplateFilter } from '../filters/WorkScheduleTemplateFilter'
import { WorkScheduleTemplateService } from '../services/WorkScheduleTemplateService'

export const useWorkScheduleTemplateStore: KsStoreHook<WorkScheduleTemplate, WorkScheduleTemplateForm, WorkScheduleTemplateFilter> = createKsStore({
  id: 'workScheduleTemplates',
  modelClass: WorkScheduleTemplate,
  formClass: WorkScheduleTemplateForm,
  filterClass: WorkScheduleTemplateFilter,
  service: WorkScheduleTemplateService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Modèle #${item.id}`,
  signalREventName: 'WorkScheduleTemplateModel',
  isReferential: true
})
